import { faker } from '@faker-js/faker'

import {
  DailyDoctorPerformance,
  DailyHospitalPerformance,
  DailyServiceOfferPerformance,
  DoctorPerformanceSummary,
  HospitalPerformanceSummary,
  ServiceOfferPerformanceSummary,
} from '../../contracts/performance'

export function createRandomDailyServiceOfferPerformance(
  customValues: Partial<DailyServiceOfferPerformance> = {},
): DailyServiceOfferPerformance {
  return {
    id: 0,
    targetDate: faker.date.between({ from: '2022-01-01', to: '2023-12-31' }).toISOString().split('T')[0],
    serviceOfferId: faker.number.int(100),
    serviceOfferTitle: faker.commerce.productName(),
    serviceOfferCountry: faker.helpers.arrayElement(['KR', 'JP']),
    hospitalId: faker.number.int(100),
    hospitalName: faker.company.name(),
    pageViewCount: faker.number.int(10000),
    consultationCount: faker.number.int(100),
    purchaseCount: faker.number.int(100),
    conversionCount: faker.number.int(100),
    conversionRate: faker.number.float(1),
    unitCpvCost: faker.number.int({ min: 0, max: 1000 }),
    totalCpvCost: faker.number.int({ min: 0, max: 10000 }),
    costPerConversion: faker.number.float({ min: 0, max: 100 }),
    ...customValues,
  }
}

export function createRandomServiceOfferPerformanceSummary(
  customValues: Partial<ServiceOfferPerformanceSummary> = {},
): ServiceOfferPerformanceSummary {
  return {
    hospitalId: faker.number.int({ min: 1, max: 100 }),
    pageViewCount: faker.number.int({ min: 1, max: 10000 }),
    conversionCount: faker.number.int({ min: 1, max: 100 }),
    conversionRate: faker.number.float(1),
    unitCpvCost: faker.number.float({ min: 0, max: 1000 }),
    totalCpvCost: faker.number.int({ min: 0, max: 10000 }),
    costPerConversion: faker.number.float({ min: 0, max: 100 }),
    ...customValues,
  }
}

export function createRandomDailyHospitalPerformance(
  customValues: Partial<DailyHospitalPerformance> = {},
): DailyHospitalPerformance {
  return {
    hospitalId: faker.number.int(1000),
    hospitalName: faker.company.name(),
    targetDate: faker.date.between({ from: '2022-01-01', to: '2023-12-31' }).toISOString().split('T')[0],
    pageViewCount: faker.number.int(10000),
    conversionCount: faker.number.int(100),
    conversionRate: faker.number.float(1),
    unitCpvCost: faker.number.float({ min: 0, max: 1000 }),
    totalCpvCost: faker.number.int({ min: 0, max: 10000 }),
    costPerConversion: faker.number.float({ min: 0, max: 100 }),
    ...customValues,
  }
}

export function createRandomHospitalPerformanceSummary(
  customValues: Partial<HospitalPerformanceSummary> = {},
): HospitalPerformanceSummary {
  return {
    pageViewCount: faker.number.int({ min: 1, max: 10000 }),
    conversionCount: faker.number.int({ min: 1, max: 100 }),
    conversionRate: faker.number.float(1),
    unitCpvCost: faker.number.float({ min: 0, max: 1000 }),
    totalCpvCost: faker.number.int({ min: 0, max: 10000 }),
    costPerConversion: faker.number.float({ min: 0, max: 100 }),
    ...customValues,
  }
}

export function createRandomDailyDoctorPerformance(
  customValues: Partial<DailyDoctorPerformance> = {},
): DailyDoctorPerformance {
  return {
    doctorId: faker.number.int(1000),
    doctorName: faker.company.name(),
    hospitalId: faker.number.int(1000),
    targetDate: faker.date.between({ from: '2022-01-01', to: '2023-12-31' }).toISOString().split('T')[0],

    pageViewCount: faker.number.int(10000),
    conversionCount: faker.number.int(100),
    conversionRate: faker.number.float(1),
    unitCpvCost: faker.number.float({ min: 0, max: 1000 }),
    totalCpvCost: faker.number.int({ min: 0, max: 10000 }),
    costPerConversion: faker.number.float({ min: 0, max: 100 }),
    ...customValues,
  }
}

export function createRandomDoctorPerformanceSummary(
  customValues: Partial<DoctorPerformanceSummary> = {},
): DoctorPerformanceSummary {
  return {
    hospitalId: faker.number.int(1000),

    pageViewCount: faker.number.int({ min: 1, max: 10000 }),
    conversionCount: faker.number.int({ min: 1, max: 100 }),
    conversionRate: faker.number.float(1),
    unitCpvCost: faker.number.float({ min: 0, max: 1000 }),
    totalCpvCost: faker.number.int({ min: 0, max: 10000 }),
    costPerConversion: faker.number.float({ min: 0, max: 100 }),
    ...customValues,
  }
}
